import React from 'react'
import promise from "../../assets/webimgs/promise.webp";

function Promises() {
  return (
         <section className="w-full bg-gray-200 dark:bg-gray-800 my-16 py-16">
        <div className="m-auto p-8 lg:w-[80%]">
          <h1 className="text-[32px] md:text-[40px] lg:text-[48px] text-transparent bg-clip-text bg-gradient-to-t from-gray-700 to-gray-300 hover:from-gray-300 hover:to-gray-700 font-ten tracking-tight font-extrabold">
            Our Promise
          </h1>
          <div className="flex flex-col-reverse lg:flex-row mt-10 gap-8 dark:text-white">
            <div className="flex flex-col gap-4 lg:w-[50%] w-full justify-center">
              <p className="font-ten text-[14px] md:text-[16px]  font-medium text-left">
                Whether you are a landscape architect, a contractor, or a
                homeowner embarking on a personal renovation, you can count on
                Konduti Stones for:
              </p>
              <ul className="font-ten space-y-4 list-inside text-[14px] md:text-[16px] font-medium text-left">
                <li className="flex flex-col">
                  {" "}
                  <span className="font-bold underline">
                    Uncompromising Quality:
                  </span>{" "}
                  Every stone, from a massive boulder to a polished marble tile,
                  meets our rigorous standards.{" "}
                </li>

                <li className="flex flex-col">
                  <span className="font-bold underline">Expert Guidance:</span>{" "}
                  Our team has deep material knowledge to help you select the
                  perfect product for longevity and aesthetics.
                </li>

                <li className="flex flex-col">
                  <span className="font-bold underline ">Reliability:</span> Our
                  direct mining operations mean better lead times and assured
                  product availability.
                </li>
              </ul>
              <p className="font-ten text-[14px] md:text-[16px] font-medium text-left">
                At Konduti Stones, we don't just sell stone—we deliver a piece
                of the earth's enduring artistry.
              </p>
            </div>
            <div className="relative lg:w-[50%] w-full  group">
              {/* Background box */}
              <div className="absolute top-0 left-0 w-full h-[90%] shadow-lg dark:shadow-slate-900 border-2 border-black dark:border-slate-200  translate-x-3 translate-y-3 transition-all duration-500 group-hover:translate-x-0 group-hover:translate-y-0"></div>

              {/* Image */}
              <img
                src={promise}
                alt="About Konduti Stones"
                className="relative w-full h-[90%] object-cover  shadow-lg transition-all duration-500 group-hover:translate-x-3 group-hover:translate-y-3"
              />
            </div>
          </div>
        </div>
      </section>
  )
}

export default Promises